module.exports = __webpack_public_path__ + "img/float_students.eb901355.png";